import React, {Component} from 'react';

class QuantityDiscount extends Component {
  render() {
    //console.log( this.props.data );
    if( this.props.data.final_price===0 ) return null;

    if( !window.__config_reactjs_cart.logon )  return null;
    if ( typeof this.props.properties["_discount"] === "undefined" || typeof this.props.properties["_discount_rate"] === "undefined" ) return null;

    return (
      <div className="discount_detail_container d-lg-inline-block px-lg-1 pl-lg-3">
        <span className="quantity">{this.props.properties["_discount_break"]}+</span>
        <span className="discount">{this.props.properties["_discount_rate"].toFixed(2).replace(/\.0+$/,'')}% Off</span>
      </div>
    )
  };
}

export default QuantityDiscount;